import { ColumnDetails, ColumnType } from '../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import {
  getApplicationControlItemActionsGridValues,
  getApplicationControlItemStatusGridValues,
} from '../../../../utils/uiSettings/applicationControl/application-control.values';
import { html, TemplateResult } from 'lit';
import {
  ApplicationControlRuleTargetsType,
  ApplicationControlStartRuleItem,
} from '@nirvana/shared/dtos/types/policies/common';

export enum Column {
  PRIORITY = 1,
  NAME = 2,
  STATUS = 3,
  TARGETS = 4,
  PERMISSION = 5,
}

export enum ColumnKeys {
  PRIORITY = 'defaultPositionInGrid',
  NAME = 'name',
  STATUS = 'active',
  TARGETS = 'targets',
  PERMISSION = 'action',
}

export const GRID_COLUMNS = [Column.PRIORITY, Column.NAME, Column.STATUS, Column.TARGETS, Column.PERMISSION];

export const FILTERS = [
  { [ColumnKeys.NAME]: { contains: '' } },
  { [ColumnKeys.STATUS]: { in: [] } },
  { [ColumnKeys.PERMISSION]: { in: [] } },
];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.STATUS, ColumnKeys.PERMISSION];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.PRIORITY,
      key: ColumnKeys.PRIORITY,
      columnName: translateFn('Priority'),
      type: ColumnType.NUMBER,
      removable: false,
      filteringDisabled: true,
    },
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Rule name'),
      type: ColumnType.STRING,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
    {
      column: Column.STATUS,
      key: ColumnKeys.STATUS,
      columnName: translateFn('Status'),
      values: getApplicationControlItemStatusGridValues(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
    {
      column: Column.TARGETS,
      key: ColumnKeys.TARGETS,
      columnName: translateFn('Targets'),
      type: ColumnType.STRING,
      removable: false,
      sortable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
    {
      column: Column.PERMISSION,
      key: ColumnKeys.PERMISSION,
      columnName: translateFn('Permission'),
      values: getApplicationControlItemActionsGridValues(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
  ];
}

export function nameCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ApplicationControlStartRuleItem }
): TemplateResult {
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${rowData.item.name}</span
  >`;
}

export function statusCellCustomRenderer(rowData: unknown & { item: ApplicationControlStartRuleItem }): TemplateResult {
  const cellText = rowData.item.active ? translateFn('Enabled') : translateFn('Disabled');
  return html`<span class="cell-label">${cellText}</span>`;
}

export function targetsCellCustomRenderer(
  rowData: unknown & { item: ApplicationControlStartRuleItem }
): TemplateResult {
  let cellText;
  switch (rowData.item.targets.type) {
    case ApplicationControlRuleTargetsType.SPECIFIC_PROCESSES:
      cellText = translateFn('{count} paths/hashes/certificates', {
        count: rowData.item.targets.processes?.length ?? 0,
      });
      break;
    case ApplicationControlRuleTargetsType.APPLICATIONS_INVENTORY:
      cellText = translateFn('{count} applications/groups', {
        count: rowData.item.targets.appInventory?.length ?? 0,
      });
      break;
    default:
      cellText = 'N/A';
      break;
  }

  return html`<span class="cell-label">${cellText}</span>`;
}
